<ng-container
    [ngSwitch]="icon">
    <mat-icon *ngSwitchCase="'edit'"
        [inline]="inline">edit</mat-icon>
    <mat-icon *ngSwitchCase="'create'"
        [inline]="inline">add</mat-icon>
    <mat-icon *ngSwitchCase="'done'"
        [inline]="inline">done</mat-icon>
    <mat-icon *ngSwitchCase="'default'"
        [inline]="inline">done</mat-icon>
    <mat-icon *ngSwitchCase="'close'"
        [inline]="inline">close</mat-icon>
    <mat-icon *ngSwitchCase="'save'"
        [inline]="inline">save</mat-icon>
    <mat-icon *ngSwitchCase="'cancel'"
        [inline]="inline">close</mat-icon>   
    <mat-icon *ngSwitchCase="'userAccount'"
        [inline]="inline">perm_identity</mat-icon>
    <mat-icon *ngSwitchCase="'home'"
        [inline]="inline">home</mat-icon>
    <mat-icon *ngSwitchCase="'search'"
        [inline]="inline">search</mat-icon>
    <mat-icon *ngSwitchCase="'clear-search'"
        [inline]="inline">clear</mat-icon>
    <mat-icon *ngSwitchCase="'delete'"
        [inline]="inline">delete</mat-icon>
    <mat-icon *ngSwitchCase="'deletionReversal'"
        [inline]="inline">undo</mat-icon>
    <mat-icon *ngSwitchCase="'settings'"
        [inline]="inline">settings</mat-icon>
    <mat-icon *ngSwitchCase="'toolbox'"
        [inline]="inline">build</mat-icon>
    <mat-icon *ngSwitchCase="'refresh'"
        [inline]="inline">sync</mat-icon>
    <mat-icon *ngSwitchCase="'date'"
        [inline]="inline">calendar_month</mat-icon>
    <mat-icon *ngSwitchCase="'user'"
        [inline]="inline">person</mat-icon>
    <mat-icon *ngSwitchCase="'account'"
        [inline]="inline">account_balance</mat-icon>
    <mat-icon *ngSwitchCase="'asset'"
        [inline]="inline">emoji_transportation</mat-icon>
    <mat-icon *ngSwitchCase="'prepayment'"
        [inline]="inline">trending_up</mat-icon>
    <mat-icon *ngSwitchCase="'accrual'"
        [inline]="inline">trending_down</mat-icon>
    <mat-icon *ngSwitchCase="'loan'"
        [inline]="inline">credit_card</mat-icon>
    <mat-icon *ngSwitchCase="'dashboard'"
        [inline]="inline">dashboard</mat-icon>
    <mat-icon *ngSwitchCase="'expand-right'"
        [inline]="inline">keyboard_double_arrow_right</mat-icon>
    <mat-icon *ngSwitchCase="'collapse-left'"
        [inline]="inline">keyboard_double_arrow_left</mat-icon>
    <mat-icon *ngSwitchCase="'collapse-up'"
        [inline]="inline">expand_less</mat-icon>
    <mat-icon *ngSwitchCase="'expand-down'"
        [inline]="inline">expand_more</mat-icon>
    <mat-icon *ngSwitchCase="'companies'"
        [inline]="inline">bookmarks</mat-icon>
    <mat-icon *ngSwitchCase="'journal'"
        [inline]="inline">swap_horizontal_circle</mat-icon>
    <mat-icon *ngSwitchCase="'transaction'"
        [inline]="inline">receipt</mat-icon>
    <mat-icon *ngSwitchCase="'organisations'"
        [inline]="inline">business_center</mat-icon>
    <mat-icon *ngSwitchCase="'diagnostics'"
        [inline]="inline">add_alert</mat-icon>
    <mat-icon *ngSwitchCase="'download'"
        [inline]="inline">get_app</mat-icon>
    <mat-icon *ngSwitchCase="'start-depreciation'"
        [inline]="inline">flight_takeoff</mat-icon>
    <mat-icon *ngSwitchCase="'kit'"
        [inline]="inline">apartment</mat-icon>
    <mat-icon *ngSwitchCase="'undo-disposal'"
        [inline]="inline">receipt</mat-icon>
    <mat-icon *ngSwitchCase="'dispose'"
        [inline]="inline">receipt</mat-icon>
    <mat-icon *ngSwitchCase="'logout'"
        [inline]="inline">logout</mat-icon>
    <mat-icon *ngSwitchCase="'support'"
        [inline]="inline">contact_support</mat-icon>
    <mat-icon *ngSwitchCase="'import'"
        [inline]="inline">upload</mat-icon>
    
</ng-container>
